import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchMenusAPI } from "./menusAPI";

export const fetchMenusData = createAsyncThunk(
    "home/fetchMenusData",
    async () => {
        const data = await fetchMenusAPI();
        return data
    }
)

const menusSlice = createSlice({
    name: "menus",
    initialState: {
        menus: {},
        loading: false,
        error: null
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
        .addCase(fetchMenusData.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchMenusData.fulfilled, (state, action) => {
            state.loading = false;

            state.menus = action.payload.data || {};
        })
        .addCase(fetchMenusData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
    }
})

export default menusSlice.reducer;